// React
import { createContext } from "react"

// Types
import type { DetailType } from "../../ReturnRecord/types"

export const DataContext = createContext<{
  detailreturn: DetailType[]
  onAddDetail: (value: DetailType) => void
}>({
  detailreturn: [],
  onAddDetail(_) {}
})